export default {
    state: {
        // 用户名
        username: localStorage.getItem('bqPhone') || '',
        // 登录的token
        token: localStorage.getItem('bqtoken') || '',
        // 判断是否登录
        // haveLogin: localStorage.getItem('haveLogin') || ''
    },
    mutations: {
        setLoginInf: (state) => {
            state.username = localStorage.getItem('bqPhone')
            state.token = localStorage.getItem('bqtoken')
            // state.haveLogin = localStorage.getItem('haveLogin')
        }
    }
}